import { Flex, Kbd, Strong, Tooltip, useSidebar } from '@buffer-mono/popcorn'

import { SidebarTrigger } from '../SidebarTrigger'
import { UserMenu } from '../UserMenu'

import styles from './SidebarFooter.module.css'

import type { JSX, ReactNode } from 'react'

export function SidebarFooterLayout({
  start,
  triggerShortcut,
}: {
  start: ReactNode
  triggerShortcut?: ReactNode
}): JSX.Element {
  const { state } = useSidebar()
  const isSidebarCollapsed = state === 'collapsed'
  const label = isSidebarCollapsed ? 'Open' : 'Close'

  return (
    <Flex
      align="center"
      direction={isSidebarCollapsed ? 'column-reverse' : 'row'}
      gap={isSidebarCollapsed ? 'sm' : 'xs'}
      className={styles.wrapper}
    >
      {start}
      <Tooltip
        align="center"
        side="right"
        content={
          <Flex display="inline-flex" gap="xs">
            <Strong>{label}</Strong>
            {triggerShortcut ? (
              <>
                <span>Click or</span>
                <span>{triggerShortcut}</span>
              </>
            ) : null}
          </Flex>
        }
      >
        <SidebarTrigger />
      </Tooltip>
    </Flex>
  )
}

export function SidebarFooter(): JSX.Element {
  return (
    <SidebarFooterLayout
      start={<UserMenu />}
      triggerShortcut={
        <>
          <Kbd color="inverted">mod</Kbd>
          <Kbd color="inverted">\</Kbd>
        </>
      }
    />
  )
}
